export const TWILIO_TOKEN_ENDPOINT_VERSIONS = {
  V2: "v2",
  V3: "v3",
} as const;
